import React, { useMemo } from "react"
import { PacSupporterSelect, TextInput, Select, Grid } from "@/components"
import { Group } from "@mantine/core"
import { useStyles } from "@/pages/campaign-form/components/donation-form/payroll-deduction-form-modal/PayrollFormModal.styles"
import { useFormContext } from "react-hook-form"
import { Radio } from "@/components/Controlled/Controlled"
import ButtonViewProfile from "@/pages/campaign-form/components/donation-form/payroll-deduction-form-modal/ButtonViewProfile"
import CurrencyInput from "@/pages/campaign-form/components/donation-form/payroll-deduction-form-modal/CurrencyInput"
import { useActionCenterSettings } from "@/services"

const { PayrollDonationType } = DjangIO.app.grassroots.types
const { PayrollFrequencyType } = DjangIO.app.ledger.types

export const AddPayrollForm = () => {
    const { classes } = useStyles()
    const { watch } = useFormContext()
    const payrollDeductionType = watch("payroll_deduction_type")
    const contact = watch("contact")

    const payrollFrequencyTypeOptions = useMemo(() => {
        return PayrollFrequencyType.items().map((item) => ({
            value: item.value.toString(),
            label: item.label,
        }))
    }, [])

    const actionCenters = useActionCenterSettings()

    const retrieveActionCenter = useMemo(() => {
        return actionCenters.data.map((actionCenter) => ({
            value: actionCenter.id,
            label: actionCenter.name,
        }))
    }, [actionCenters.data])

    return (
        <>
            <div className={classes.stack}>
                <div className={classes.stackFullCol}>
                    <div className={classes.contactButton}>
                        <PacSupporterSelect
                            name="contact"
                            label="Select contact"
                            placeholder="Select contact"
                            withAsterisk
                            multi={false}
                            clearable
                            rules={{ required: "You must select a Contact" }}
                        />
                    </div>
                    <ButtonViewProfile contact={contact} />
                </div>
                <div className={classes.stackRow}>
                    <div className={classes.stackCol}>
                        <Select
                            required
                            withAsterisk
                            placeholder="Payroll Frequency"
                            label="Select Payroll Frequency"
                            data={payrollFrequencyTypeOptions}
                            name="payroll_frequency"
                            data-cy="payroll_frequency"
                        />
                    </div>
                    <div className={classes.stackCol} />
                </div>
            </div>

            <Radio.Group
                name="payroll_deduction_type"
                label="Payroll Deduction Type"
                transform={{
                    input: (input: string | number) => String(input),
                    output: (output: string) => Number(output),
                }}
            >
                <Group>
                    {PayrollDonationType.items().map((item) => (
                        <div>
                            <Radio value={item.value.toString()} label={item.label} />
                        </div>
                    ))}
                </Group>
            </Radio.Group>

            {payrollDeductionType === PayrollDonationType.amount.value ? (
                <div className={classes.stackRow}>
                    <div className={classes.stackCol}>
                        <CurrencyInput />
                    </div>
                    <div className={classes.stackCol} />
                </div>
            ) : (
                <div className={classes.stackRow}>
                    <div className={classes.stackCol}>
                        <TextInput
                            required
                            withAsterisk
                            name="percentage_text"
                            data-cy="percentage_text"
                            placeholder="Percentage text (e.g. 1/2 of 1%)"
                            label="Percentage Text"
                        />
                    </div>
                    <div className={classes.stackCol}>
                        <TextInput
                            type="number"
                            min={0}
                            step="any"
                            max={1}
                            required
                            withAsterisk
                            placeholder="Payroll value (e.g. 0.005)"
                            name="percentage_value"
                            data-cy="percentage_value"
                            label="Percentage value per payroll"
                        />
                    </div>
                </div>
            )}

            {actionCenters.data.length === 1 && (
                <Grid>
                    <Grid.Col>
                        <Select
                            withAsterisk
                            name="action_center"
                            label="Select Action Center"
                            data={retrieveActionCenter as any}
                            rules={{ required: "You must select one Action Center" }}
                        />
                    </Grid.Col>
                </Grid>
            )}
        </>
    )
}
